module.exports = __webpack_public_path__ + "static/media/77.9a5bba6e.png";